export const FETCH_CONFIGURATION = "FETCH_CONFIGURATION";
